import { gql } from "config/graphql";
import { IUser } from "config/types";
import { gqlQuery } from "store/apollo";

interface IFetchPendingPolicyResponse {
  data: {
    me: IUser;
  };
}

export const fetchPendingPolicy = (): Promise<IFetchPendingPolicyResponse> => {
  const query = gql`
    query pendingPolicy {
      me {
        activeConstellations {
          activeInsuranceMembership {
            id
            pendingPolicy {
              id
              amount
              status
              termDuration
              termUnit
              effectiveAt
              pausedAt
              terminatesAt
              accountsProduct {
                amount
                billingFrequency
              }
              documents {
                id
                name
                description
                slug
                html {
                  url
                  fileName
                }
                pdf {
                  url
                  fileName
                }
                version
              }
            }
          }
        }
      }
    }
  `;

  return gqlQuery<IFetchPendingPolicyResponse["data"]>({ query });
};
